<template>
  <section class="contact-info-section">
    <div class="container">
      <div class="section-header text-center mb-5 animate-on-scroll fade-in-up">
        <h2 class="section-title">Contáctanos</h2>
        <p class="section-subtitle">
          Estamos aquí para responder tus preguntas y ayudarte a elegir el plan perfecto para ti y tu familia.
        </p>
      </div>
      
      <div class="row">
        <div class="col-lg-4 col-md-6 mb-4">
          <div class="contact-card animate-on-scroll fade-in-up">
            <div class="contact-icon">
              <img :src="contactPhoneIcon" alt="Teléfono" class="contact-icon-image" />
            </div>
            <h4 class="contact-title">Teléfono</h4>
            <p class="contact-info">(214) 888-9000</p>
            <p class="contact-hours">Lun-Dom: 09:00 AM - 10:00 PM</p>
          </div>
        </div>
        
        <div class="col-lg-4 col-md-6 mb-4">
          <div class="contact-card animate-on-scroll fade-in-up" style="animation-delay: 0.1s">
            <div class="contact-icon">
              <img :src="contactEmailIcon" alt="Email" class="contact-icon-image" />
            </div>
            <h4 class="contact-title">Email</h4>
            <p class="contact-info">info@hispanomedicalplan.com</p>
            <p class="contact-hours">Respuesta en 24 horas</p>
          </div>
        </div>
        
        <div class="col-lg-4 col-md-6 mb-4">
          <div class="contact-card animate-on-scroll fade-in-up" style="animation-delay: 0.2s">
            <div class="contact-icon">
              <img :src="contactLocationIcon" alt="Ubicación" class="contact-icon-image" />
            </div>
            <h4 class="contact-title">Oficina Principal</h4>
            <p class="contact-info">6501 Preston rd, suite 100</p>
            <p class="contact-hours">Plano, Texas 75024</p>
            <p class="contact-link">
              <a href="https://bit.ly/CLocalidades" target="_blank">
                <i class="fas fa-link"></i> https://bit.ly/CLocalidades
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactInfoSection',
  data() {
    return {
      contactPhoneIcon: require('@/assets/lp/Recurso 59@300x.png'),
      contactEmailIcon: require('@/assets/lp/Recurso 60@300x.png'),
      contactLocationIcon: require('@/assets/lp/Recurso 61@300x.png')
    };
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.contact-info-section {
  padding: 100px 0;
  background: linear-gradient(135deg, $landing-primary-color 0%, $landing-primary-color 75%, $landing-secondary-color 100%);
  color: white;
  
  .section-header {
    margin-bottom: 4rem;
    
    .section-title {
      color: white;
      font-size: 3.5rem;
      font-weight: 700;
      margin-bottom: 1.5rem;
      text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }
    
    .section-subtitle {
      color: white;
      font-size: 1.8rem;
      font-weight: 500;
      line-height: 1.6;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }
  }
  
  .contact-card {
    background: white;
    border-radius: 15px;
    padding: 2rem;
    text-align: center;
    transition: all 0.3s ease;
    border: 2px solid $landing-border-light;
    height: 100%;
    box-shadow: 0 5px 20px $landing-primary-rgba-08;
    
    &:hover {
      transform: translateY(-5px);
      background: white;
      border-color: $landing-primary-color;
      box-shadow: 0 10px 30px rgba(40, 167, 69, 0.2);
    }
    
    .contact-icon {
      width: 100px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 1.5rem;
      transition: all 0.3s ease;
      
      .contact-icon-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      
      i {
        font-size: 2rem;
        color: white;
      }
    }
    
    &:hover .contact-icon {
      transform: scale(1.1);
    }
    
    .contact-title {
      font-size: 1.8rem;
      font-weight: 700;
      color: $landing-primary-color;
      margin-bottom: 1rem;
    }
    
    .contact-info {
      font-size: 1.5rem;
      color: $landing-text-dark;
      margin-bottom: 0.5rem;
      font-weight: 600;
    }
    
    .contact-hours {
      font-size: 1.2rem;
      color: $landing-text-dark;
      margin: 0;
      font-weight: 500;
    }
    
    .contact-link {
      margin-top: 0.75rem;
      
      a {
        color: $landing-primary-color;
        text-decoration: none;
        font-size: 1rem;
        transition: all 0.3s ease;
        
        &:hover {
          color: $landing-primary-dark;
          text-decoration: underline;
        }
        
        i {
          margin-right: 0.5rem;
        }
      }
    }
  }
  
  @media (max-width: 991px) {
    padding: 80px 0;
    
    .section-header {
      .section-title {
        font-size: 3rem;
      }
      
      .section-subtitle {
        font-size: 1.5rem;
      }
    }
  }
  
  @media (max-width: 768px) {
    padding: 60px 0;
    
    .section-header {
      .section-title {
        font-size: 2rem;
      }
      
      .section-subtitle {
        font-size: 1.1rem;
      }
    }
    
    .contact-card {
      padding: 1.5rem;
      
      .contact-icon {
        width: 80px;
        height: 80px;
        
        .contact-icon-image {
          width: 100%;
          height: 100%;
        }
      }
      
      .contact-title {
        font-size: 1.5rem;
      }
      
      .contact-info {
        font-size: 1.3rem;
      }
      
      .contact-hours {
        font-size: 1.1rem;
      }
    }
  }
}
</style>
